import { useReducedMotion } from 'framer-motion';
import { useSpecSettings } from '../contexts/SpecSettingsContext';

/** True when the spec's reduced-motion toggle is on or the OS asks for reduced motion. */
export function useMotionPreference(): boolean {
  const { reducedMotion } = useSpecSettings();
  const system = useReducedMotion();
  return reducedMotion || !!system;
}
